module.exports = __webpack_public_path__ + "ecbdfd55dc5246e9ea8c07d7187cc7b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/jiubi.jpg
// module id = 595
// module chunks = 30